import { useTenantBrandColor } from '@/store/tenantBrandColor';
import {
  companyMenuLetterPresentation,
  CRM_AVATAR_SOFT_BG,
  CRM_AVATAR_SOFT_TEXT,
  normalizeHexColor,
  userProfileLetterPresentation,
  type AvatarBrandPresentation
} from '@/utils/avatarPresentation';

type UserLike = {
  company?: { main_color?: string | null } | null;
} | null;

/**
 * Navbar user avatar (letter fallback): `user.company.main_color` then tenant snapshot, then soft default.
 */
export function useUserProfileLetterAvatarProps(
  user: UserLike
): AvatarBrandPresentation {
  const tenant = useTenantBrandColor();
  const fromCompany = normalizeHexColor(user?.company?.main_color);
  if (fromCompany) return { color: fromCompany };
  return userProfileLetterPresentation(tenant);
}

/**
 * Sidebar company row (letter fallback): company profile query, then tenant snapshot, then soft default.
 */
export function useCompanyMenuLetterAvatarProps(
  ...queryCandidates: unknown[]
): AvatarBrandPresentation {
  const tenant = useTenantBrandColor();
  return companyMenuLetterPresentation(tenant, ...queryCandidates);
}

/** Search / drawer rows: no tenant — soft default only when entity has no color. */
export function useEntitySearchRowAvatarProps(): AvatarBrandPresentation {
  return {
    color: CRM_AVATAR_SOFT_BG,
    textColor: CRM_AVATAR_SOFT_TEXT
  };
}
